import { makeActionCreator } from '../../config/store/utils'
import { createComparatorProviders } from '../../services/comparatorCharts'
import theme from '../../config/styles/theme'

export const COMPARATOR_PROVIDERS = 'COMPARATOR_PROVIDERS'
export const COMPARATOR_PROVIDERS_SUCCESS = 'COMPARATOR_PROVIDERS_SUCCESS'
export const COMPARATOR_PROVIDERS_ERROR = 'COMPARATOR_PROVIDERS_ERROR'
export const onComparatorProviders = makeActionCreator(COMPARATOR_PROVIDERS)
export const onComparatorProvidersSuccess = makeActionCreator(COMPARATOR_PROVIDERS_SUCCESS, 'payload')
export const onComparatorProvidersError = makeActionCreator(COMPARATOR_PROVIDERS_ERROR, 'payload')
export const onComparatorProvidersThunk =
  ({ year, idEntity }, type, firstName, secondName) =>
  async dispatch => {
    dispatch(onComparatorProviders())

    try {
      const response = await createComparatorProviders({ year, idEntity })

      if (response.data.success !== 'OK') {
        return dispatch(onComparatorProvidersError(response.data.errores))
      }

      const firstEntity = response.data.payload[0].data1
      const secondEntity = response.data.payload[0].data2
      // Categories
      const categories = ['Micro', 'Pequeña', 'Mediana', 'Grande', 'Sin clasificación']
      // Micro
      const firstMicro = firstEntity.find(item => item.tamanoProveedor === 'Micro')
      const secondMicro = secondEntity.find(item => item.tamanoProveedor === 'Micro')
      // Pequeña
      const firstSmall = firstEntity.find(item => item.tamanoProveedor === 'Pequeña')
      const secondSmall = secondEntity.find(item => item.tamanoProveedor === 'Pequeña')
      // Mediana
      const firstMedium = firstEntity.find(item => item.tamanoProveedor === 'Mediana')
      const secondMedium = secondEntity.find(item => item.tamanoProveedor === 'Mediana')
      // Grande
      const firstBig = firstEntity.find(item => item.tamanoProveedor === 'Grande')
      const secondBig = secondEntity.find(item => item.tamanoProveedor === 'Grande')
      // Sin Clasificación
      const firstUnclasified = firstEntity.find(item => item.tamanoProveedor === 'NoClasificado')
      const secondUnclasified = secondEntity.find(item => item.tamanoProveedor === 'NoClasificado')
      // Amounts
      const firstAmounts = {
        name: firstName,
        data: [
          firstMicro.montoBrutoCLPAnualTP,
          firstSmall.montoBrutoCLPAnualTP,
          firstMedium.montoBrutoCLPAnualTP,
          firstBig.montoBrutoCLPAnualTP,
          firstUnclasified.montoBrutoCLPAnualTP
        ],
        color: theme.palette.charts.navyBlue
      }
      const secondAmounts = {
        name: secondName,
        data: [
          secondMicro.montoBrutoCLPAnualTP,
          secondSmall.montoBrutoCLPAnualTP,
          secondMedium.montoBrutoCLPAnualTP,
          secondBig.montoBrutoCLPAnualTP,
          secondUnclasified.montoBrutoCLPAnualTP
        ],
        color: theme.palette.charts.darkRed
      }
      // Orders
      const firstOrders = {
        name: firstName,
        data: [
          firstMicro.nroOCAnualTP,
          firstSmall.nroOCAnualTP,
          firstMedium.nroOCAnualTP,
          firstBig.nroOCAnualTP,
          firstUnclasified.nroOCAnualTP
        ],
        color: theme.palette.charts.navyBlue
      }
      const secondOrders = {
        name: secondName,
        data: [
          secondMicro.nroOCAnualTP,
          secondSmall.nroOCAnualTP,
          secondMedium.nroOCAnualTP,
          secondBig.nroOCAnualTP,
          secondUnclasified.nroOCAnualTP
        ],
        color: theme.palette.charts.darkRed
      }
      // Percentages
      const firstPercentages = {
        name: firstName,
        data: [
          firstMicro.porcentaje,
          firstSmall.porcentaje,
          firstMedium.porcentaje,
          firstBig.porcentaje,
          firstUnclasified.porcentaje
        ],
        color: theme.palette.charts.navyBlue
      }
      const secondPercentages = {
        name: secondName,
        data: [
          secondMicro.porcentaje,
          secondSmall.porcentaje,
          secondMedium.porcentaje,
          secondBig.porcentaje,
          secondUnclasified.porcentaje
        ],
        color: theme.palette.charts.darkRed
      }
      const dataByType = {
        amount: [firstAmounts, secondAmounts],
        oc: [firstOrders, secondOrders],
        percentage: [firstPercentages, secondPercentages]
      }
      const payload = {
        categories,
        chart: dataByType[type],
        csv: [
          [
            'Organismo comprador',
            'Año',
            'Tipo de proveedor',
            'Monto total transado durante el año (CLP)',
            'Nº órdenes de compra',
            'Monto porcentual'
          ],
          ...(firstEntity
            .concat(secondEntity)
            .map(item => [
              item.name,
              item.year,
              item.tamanoProveedor === 'NoClasificado' ? 'Sin clasificación' : item.tamanoProveedor,
              item.montoBrutoCLPAnualTP,
              item.nroOCAnualTP,
              item.porcentaje
            ]) || [])
        ]
      }

      return dispatch(onComparatorProvidersSuccess(payload))
    } catch (error) {
      return dispatch(onComparatorProvidersError(error))
    }
  }
